import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Gate that requires a logged-in customer.
 * Not-logged-in users get redirected to /account (the login/register screen).
 */
const RequireCustomer = ({ children }) => {
  const { customer, loading } = useAuth();
  const location = useLocation();
  const fromState = React.useMemo(
    () => ({ from: location.pathname + location.search }),
    [location.pathname, location.search],
  );

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-red-500" size={28} />
      </div>
    );
  }
  if (!customer) {
    // Preserve where they were heading so we can bounce them back after login
    return <Navigate to="/account" replace state={fromState} />;
  }
  return children;
};

export default RequireCustomer;
